import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { STORE_UI } from 'Core/constants'
import { SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers/storagePageSizeConstant'

import { AccountCategory } from 'Portals/Customer/entities'
import { AccountCategoryRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

export class AccountCategoryTable extends TableStore<AccountCategory.Basic> {
	constructor(public rootStore: RootStore) {
		super(storagePageSizeConstant('accountCategory'))
		makeObservable(this)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				defaultSort,
				repository: AccountCategoryRepo.getList
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}
}
